

var _squid = require('squid');

require('./directive');

require('./sepaAgreement/route');

require('./sepaMandate/route');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$MemberSepaRoute', function () {

    return _squid.$ComponentRoute.extend('MemberSepaRoute', {

        name: 'membersepa',

        directive: 'xo-member-sepa',
        titleContent: 'directDebitAgreement.sepaTitle',

        children: [{
            name: '$XOSepaAgreementRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }, {
            name: '$XOSepaMandateRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/route.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/route.js
// module chunks = 0